import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    /**
     * Set an item in localStorage
     */
    setItem(key: string, value: string): void {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error('Error saving to localStorage', error);
        }
    }

    /**
     * Get an item from localStorage
     */
    getItem(key: string): string | null {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            console.error('Error reading from localStorage', error);
            return null;
        }
    }

    /**
     * Remove an item from localStorage
     */
    removeItem(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('Error removing from localStorage', error);
        }
    }

    /**
     * Clear all items from localStorage
     */
    clear(): void {
        try {
            localStorage.clear();
        } catch (error) {
            console.error('Error clearing localStorage', error);
        }
    }

    /**
     * Check if a key exists in localStorage
     */
    hasItem(key: string): boolean {
        return this.getItem(key) !== null;
    }

    /**
     * Get and parse JSON from localStorage
     */
    getObject<T>(key: string): T | null {
        const item = this.getItem(key);
        if (!item) return null;

        try {
            return JSON.parse(item) as T;
        } catch (error) {
            console.error('Error parsing JSON from localStorage', error);
            return null;
        }
    }

    /**
     * Stringify and set object in localStorage
     */
    setObject<T>(key: string, value: T): void {
        try {
            const serialized = JSON.stringify(value);
            this.setItem(key, serialized);
        } catch (error) {
            console.error('Error stringifying object for localStorage', error);
        }
    }
}
